import Vue from 'vue';
import App from './App.vue';

import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';

Vue.use(VueCustomTooltip);

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#app')
